module.exports = __webpack_public_path__ + "img/activate-phone.5eacccd3.jpg";